/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { GeneralRestApiOptions } from './types';

export const createGeneralMerchantSubscriptionsRepository = (
    options: GeneralRestApiOptions
): Types.GeneralMerchantSubscriptionsRepository => ({
    async updateBankEstimateFees(params, requestOptions) {
        return options.request('/merchantSubscriptions/updateBankEstimateFees', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async upsert(params, requestOptions) {
        return options.request('/merchantSubscriptions/upsert', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
